import {
  Document,
  Page,
  StyleSheet,
  Text,
  View,
  Font,
} from "@react-pdf/renderer";
import { format } from "date-fns-tz";
import { useEffect, useState } from "react";

Font.register({
  family: "Roboto",
  src: "/fonts/Roboto/static/Roboto-Regular.ttf",
});
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 35,
    paddingHorizontal: 35,
    margin: 0,
  },
  container: {
    flexDirection: "row",
    marginBottom: 3,
  },
  column: {
    flexGrow: 1,
    marginRight: 10,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 8,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },

  fieldName: {
    color: "grey",
    fontSize: 8,
  },
  fieldValue: {
    fontSize: 10,
    color: "black",
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    width: "auto",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_No: {
    width: "10%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Ts: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Or: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Name: {
    width: "10%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
    fontFamily: "Roboto",
  },
  tableCell_A: {
    width: "6%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Kgs: {
    width: "7%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Up: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Amt: {
    width: "6%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
    fontFamily: "Roboto",
  },
  tableCell_Tkgs: {
    width: "10%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Tamt: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  tableCell_Remarks: {
    width: "15%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    padding: 3,
    fontSize: "8px",
    flexGrow: 1,
  },
  sectionHeader: {
    fontWeight: "bold",
    color: "red",
    fontSize: 12,
    textAlign: "center",
    marginBottom: 2,
  },
});

export default function ExpensePrint({ records, date, dateto, profile }) {
  // const retailDataPrint = records;

  return (
    <Document>
      <Page size={"LETTER"} style={styles.body} orientation="landscape">
        <Text style={styles.header} fixed>
          K-GAZ
        </Text>
        <View style={styles.container}>
          <View style={styles.column}>
            <Text style={styles.fieldName}>
              Prepared By:{" "}
              <Text
                style={styles.fieldValue}
              >{`${profile.firstName} ${profile.lastName}`}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.container}>
          <View style={styles.column}>
            <Text style={styles.fieldName}>
              Date:{" "}
              <Text style={styles.fieldValue}>
                {date} - {dateto}
              </Text>
            </Text>
          </View>
          <View style={styles.column}>
            <Text style={styles.fieldName}>
              Print timestamp:{" "}
              <Text style={styles.fieldValue}>
                {format(new Date(), "yyyy-MM-dd HH:mm:ss", {
                  timeZone: "Asia/Manila",
                })}
              </Text>
            </Text>
          </View>
        </View>

        <View style={{ marginBottom: 15 }}>
          <Text style={styles.sectionHeader}>Expense Report</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCell_No}>
                <Text>Category</Text>
              </View>
              <View style={styles.tableCell_Ts}>
                <Text>Description</Text>
              </View>
              <View style={styles.tableCell_Or}>
                <Text>Voucher</Text>
              </View>
              <View style={styles.tableCell_Name}>
                <Text>Created By</Text>
              </View>
              <View style={styles.tableCell_Amt}>
                <Text>Amount</Text>
              </View>
              <View style={styles.tableCell_Amt}>
                <Text>Returned Amount</Text>
              </View>
              <View style={styles.tableCell_Kgs}>
                <Text>Date</Text>
              </View>
            </View>

            {records.map((expenseDetails, index) => (
              <View key={index} style={styles.tableRow}>
                <View style={styles.tableCell_No}>
                  <Text>{expenseDetails.category}</Text>
                </View>
                <View style={styles.tableCell_Ts}>
                  <Text>{expenseDetails.e_desc}</Text>
                </View>
                <View style={styles.tableCell_Or}>
                  <Text>{expenseDetails.voucher}</Text>
                </View>
                <View style={styles.tableCell_Name}>
                  <Text>{expenseDetails.addedby}</Text>
                </View>
                <View style={styles.tableCell_Amt}>
                  <Text style={{ textAlign: "right" }}>
                    ₱{" "}
                    {Number(expenseDetails.amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Text>
                </View>
                <View style={styles.tableCell_Amt}>
                  <Text style={{ textAlign: "right" }}>
                    ₱{" "}
                    {Number(expenseDetails.ret_amt).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Text>
                </View>
                <View style={styles.tableCell_Kgs}>
                  <Text>{expenseDetails.date}</Text>
                </View>
              </View>
            ))}
            <View style={styles.tableRow}>
              <View style={styles.tableCell_No}>
                <Text style={{ fontWeight: "bold" }}>Grand Total</Text>
              </View>
              <View style={styles.tableCell_Ts}></View>
              <View style={styles.tableCell_Or}></View>
              <View style={styles.tableCell_Name}></View>
              <View style={styles.tableCell_Amt}>
                <Text style={{ fontWeight: "bold", textAlign: "right" }}>
                  ₱{" "}
                  {records
                    .reduce(
                      (sum, item) => sum + Number(item.amount || 0),
                      0
                    )
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </Text>
              </View>
              <View style={styles.tableCell_Amt}>
                <Text style={{ fontWeight: "bold", textAlign: "right" }}>
                  ₱{" "}
                  {records
                    .reduce(
                      (sum, item) => sum + Number(item.ret_amt || 0),
                      0
                    )
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </Text>
              </View>
              <View style={styles.tableCell_Kgs}></View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}
